import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ROUTES } from "@/config/types";
import { About, Contact, TailoredSoftwareSolutions, EcommerceSolutions, Home, MobileAppSolutions, UserExperience, WebSolutions } from "@/screens";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store/store";
import { setIsLoading, setIsSplashScreenLoading } from "@/store/slices/appSlice";
import { fetchAppConfigData } from "@/services/configService";

// import {} from 'framer-motion' /dist/framer-motion
export const AnimatedRoutes = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const navigationRoute = useSelector((store: RootState) => store.app.navigation)
  const isLoading = useSelector((store: RootState) => store.app.isLoading)
  const isSplashScreenLoading = useSelector((store: RootState) => store.app.isSplashScreenLoading)

  let t1, t2, t3
  useEffect(() => {
    fetchAppConfigData()
  }, [])

  useEffect(() => {
    const hashTarget = navigationRoute?.split("#")[1]

    setTimeout(() => {
      if (hashTarget) {
        const targetSection = document.getElementById(hashTarget)

        if (targetSection) {
          targetSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }

        return
      }

      window.scroll({
        top: 0,
      });
    }, 1000)
    if (navigationRoute) {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t2)
      if (!isSplashScreenLoading) dispatch(setIsLoading(true))
      t1 = setTimeout(() => {
        navigate(navigationRoute)
      }, 600)
    }
    t2 = setTimeout(() => {
      dispatch(setIsLoading(false))

    }, 2700)
    t3 = setTimeout(() => {
      dispatch(setIsSplashScreenLoading(false))

    }, 2700)


    // 
  }, [navigationRoute])
  // const isApiLoading = useSelector((state: RootState) => state.admin.isApiLoading);
  // const apiResponse = useSelector((state: RootState) => state.admin.apiResponse);

  return (
    <>
      <div className={`page-loader ${isLoading && !isSplashScreenLoading ? 'show ' : ''} ${isSplashScreenLoading ? 'showSplashScreen' : ''}`}></div>
      <AnimatePresence>
        {/* <div className={`api-response-alert ${apiResponse ? ' loaded ' : ''}`}>
        <div className={`alert text-center alert-${apiResponse?.success ? 'success ' : apiResponse==undefined?  ' ' : ' danger '}`} role="alert">
          {apiResponse?.message}
        </div>
      </div> */}
        {/* <div className={`admin-loader-wrapper ${!isApiLoading ? ' loaded ' : ''}`}
        style={{
          height: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0, left: 0,
          background: 'black',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999999,
        }}

      >
        <div className="spinner">
          <div className="spinner-item"></div>
          <div className="spinner-item"></div>
          <div className="spinner-item"></div>
          <div className="spinner-item"></div>
          <div className="spinner-item"></div>
        </div>
      </div> */}


        <Routes location={location} key={location.pathname}>
          <Route path="" element={<Home />} />
          <Route path={ROUTES.CONTACT} element={<Contact />} />
          <Route path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.TAILORED_SOFTWARE_SOLUTIONS} element={<TailoredSoftwareSolutions />} />
          <Route path={ROUTES.WEB_SOLUTIONS} element={<WebSolutions />} />
          <Route path={ROUTES.MOBILE_APP_SOLUTIONS} element={<MobileAppSolutions />} />
          <Route path={ROUTES.ECOMMERCE_SOLUTIONS} element={<EcommerceSolutions />} />

          {/* {isLoggedIn ? ( */}

          <Route path='*' element={<Navigate to={"/"} />} />

        </Routes>
      </AnimatePresence>

    </>
  );
};
